export const API_BASE = process.env.VUE_APP_API_BASE
	?? (typeof window !== 'undefined' ? window.location.origin : '');
export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || '';